// extracted by mini-css-extract-plugin
export default {"ScrollToTopButton":"style_ScrollToTopButton__BJFTr","show":"style_show__g-3+f","fadeIn":"style_fadeIn__fkB-j","hide":"style_hide__Hpnub","fadeOut":"style_fadeOut__pyn8g"};